module.exports = __webpack_public_path__ + "img/tariff_SMS500.292e9acd.svg";